interface RiskTagProps {
  level: '低' | '中' | '高' | '重大';
  score?: number;
}

const styleByLevel: Record<RiskTagProps['level'], string> = {
  低: 'bg-emerald-100 text-emerald-700',
  中: 'bg-amber-100 text-amber-700',
  高: 'bg-orange-100 text-orange-700',
  重大: 'bg-red-100 text-red-700',
};

export default function RiskTag({ level, score }: RiskTagProps) {
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11.5px] font-medium ${styleByLevel[level]}`}
    >
      {level}
      {/* Issue 5: 风险分统一 2 位小数 */}
      {typeof score === 'number' && <span className="opacity-80">· {score.toFixed(2)}</span>}
    </span>
  );
}
